import React, { useState } from 'react'
import Page from '../../../../ui/Page'
import RowSpan from '../../../../ui/RowSpan'
import { Button, Popconfirm, Space, Table, TableColumnsType, Typography } from 'antd'
import { DeleteOutlined, DownloadOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import useCounterpartyAgreement from './useCounterpartyAgreement'
import { CounterpartyAgreementDtoRequest, CounterpartyAgreementDtoResponse } from '../../../../interfaces/CounterpartyDtos'
import MultiLangName from '../../../../ui/Table/MultiLangName'
import useModal from '../../../../ui/Modal/useModal'
import CounterpartyAgreementModal from './CounterpartyAgreementModal'

const CounterpartyAgreement = () => {
    const { agreements, loading, agreementForm, handleAdd, handleDelete, handleEdit, handleDownload } = useCounterpartyAgreement();
    const { isModalOpen, handleCancel, showModal: handleShowModal } = useModal();
    const [modalType, setModalType] = useState<'add' | 'edit'>('add');
    const [currentAgreement, setCurrentAgreement] = useState<CounterpartyAgreementDtoResponse | null>(null);

    const openModal = (type: 'add' | 'edit', agreement?: CounterpartyAgreementDtoResponse) => {
        setModalType(type);
        setCurrentAgreement(agreement || null);
        agreementForm.setFieldsValue({
            ...agreement,
            counterpartyId: agreement?.counterparty.id,
            agreementTypeId: agreement?.agreementType.id,
        });
        handleShowModal();
    };

    const handleModalCancel = () => {
        agreementForm.resetFields();
        handleCancel();
    };

    const handleModalSubmit = (values: CounterpartyAgreementDtoRequest) => {
        if (modalType === 'add') {
            handleAdd(values);
        } else if (modalType === 'edit' && currentAgreement) {
            handleEdit(currentAgreement.id, values);
        }
        handleCancel();
    };



    const columns: TableColumnsType<CounterpartyAgreementDtoResponse> = [
        {
            title: 'Counterparty name',
            dataIndex: 'counterpartyName',
            key: 'counterpartyName',
            render: (text, record) => (
                <MultiLangName
                    nameRu={record.counterparty.counterPartyForm.shortNameRu + " " + record.counterparty.nameRu}
                    nameKz={record.counterparty.counterPartyForm.shortNameKz + " " + record.counterparty.nameKz}
                    nameEn={record.counterparty.counterPartyForm.shortNameEn + " " + record.counterparty.nameEn}
                />
            )
        },
        {
            title: "Counterparty BIN",
            dataIndex: "counterpartyBin",
            key: "counterpartyBin",
            width: "10%",
            render: (text, record) => (
                <Typography.Text>{record.counterparty.bin}</Typography.Text>
            )
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            width: "10%",
            render: (text, record) => (
                <MultiLangName
                    nameRu={record.agreementType.nameRu}
                    nameKz={record.agreementType.name}
                    nameEn={record.agreementType.nameEn}
                />
            )
        },
        {
            title: "Start date",
            dataIndex: "startDate",
            key: "startDate",
            width: "10%",
        },
        {
            title: "End date",
            dataIndex: "endDate",
            key: "endDate",
            width: "10%",
        },
        {
            title: "Actions",
            key: "actions",
            width: "10%",
            render: (text, record) => (
                <Space>
                    {record.fileId && <Button
                        type="primary"
                        onClick={() => handleDownload(record.fileId)}
                        icon={<DownloadOutlined />}
                    >
                        Download File
                    </Button>}
                    <Button icon={<EditOutlined />} onClick={() => openModal('edit', record)} />
                    <Popconfirm
                        title="Are you sure to delete this agreement?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                        />
                    </Popconfirm>
                </Space>
            )
        }
    ];

    return (
        <Page title='Counterparty Agreements'>
            <RowSpan
                left={
                    <Space direction="vertical" style={{ width: '100%' }}>

                    </Space>
                }
                right={
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal('add')} style={{ marginBottom: 16 }}>
                        Add Agreement
                    </Button>
                }
            />
            <Table
                bordered
                dataSource={agreements?.sort((a, b) => a.id - b.id)}
                rowKey={"id"}
                columns={columns}
                loading={loading}
            />
            <CounterpartyAgreementModal
                visible={isModalOpen}
                type={modalType}
                parentForm={agreementForm}
                onClose={handleModalCancel}
                onSubmit={handleModalSubmit}
            />
        </Page>
    )
}

export default CounterpartyAgreement